import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";
import { BasePagingResponse } from "../_types";
import { GetSalesmanMonthlyDataRequest, ISalesmanMonthlyData } from "./types";

export const getSalesmanMonthlyData = async (data: GetSalesmanMonthlyDataRequest): Promise<BasePagingResponse<ISalesmanMonthlyData[]>> => {
    const response = await axiosInstance.post<BasePagingResponse<ISalesmanMonthlyData[]>>(
        "/SalesmanBonus/GetMonthlyDataList",
        data
    );
    return response.data;
};

export function useGetSalesmanMonthlyData() {
    return useMutation<BasePagingResponse<ISalesmanMonthlyData[]>, Error, GetSalesmanMonthlyDataRequest>(
        (variables) => getSalesmanMonthlyData(variables)
    );
}
